import * as Requests from "../../services";
import { recoverPasswordTypes } from "../actionTypes/recoverPasswordTypes";
import makeActionCreator from "./makeActionCreator";

export const loader = makeActionCreator(
  recoverPasswordTypes.RECOVER_EMAIL_LOADER,
  "email_loader"
);
export const emailDetails = makeActionCreator(
  recoverPasswordTypes.RECOVER_EMAIL,
  "email"
);
export const emailSuccess = makeActionCreator(
  recoverPasswordTypes.RECOVER_EMAIL_SUCCESS,
  "email_success"
);
export const emailFailure = makeActionCreator(
  recoverPasswordTypes.RECOVER_EMAIL_SUCCESS,
  "email_failure"
);

export const resetLoader = makeActionCreator(
  recoverPasswordTypes.RESET_PASSWORD_LOADER,
  "resetPassword_loader"
);
export const resetPasswordDetails = makeActionCreator(
  recoverPasswordTypes.RESET_PASSWORD_DETAILS,
  "resetPasswordDetails:"
);
export const resetPasswordFailure = makeActionCreator(
  recoverPasswordTypes.RESET_PASSWORD_FAILURE,
  "resetPasswordFailure"
);
export const resetPasswordSuccess = makeActionCreator(
  recoverPasswordTypes.RESET_PASSWORD_DETAILS,
  "resetPasswordSuccess"
);

export const forgotPasswordAction = (payload) => {
  return async (dispatch) => {
    dispatch(loader(true));
    try {
      const response = await Requests.forgetPasswordCall(payload);
      if (response.data) {
        dispatch(emailSuccess(true));
        return { status: true, message: response?.data?.message };
      }
    } catch (err) {
      dispatch(emailFailure(true));
      return { status: false, message: err?.response?.data?.error };
    }
  };
};

export const storeForgotPasswordAction = (payload) => {
    return async (dispatch) => {
      dispatch(loader(true));
      try {
        const response = await Requests.storeForgotPasswordCall(payload);
        if (response.data) {
          dispatch(emailSuccess(true));
          return { status: true, message: response?.data?.message };
        }
      } catch (err) {
        dispatch(emailFailure(true));
        return { status: false, message: err?.response?.data?.error };
      }
    };
  };

  export const resetPasswordAction = (id, token, payload) => {
    return async (dispatch) => {
      dispatch(resetLoader(true));
      try {
        const response = await Requests.userResetPasswordCall(id, token, payload);
        if (response.data) {
          dispatch(resetPasswordSuccess(true));
          return { status: true, message: response?.data?.message };
        }
      } catch (err) {
        dispatch(resetPasswordFailure(true))
        return { status: false, message: err?.response?.data?.error };
      }
    };
  };

  export const storeResetPasswordAction = (id, token, payload) => {
    return async (dispatch) => {
      dispatch(resetLoader(true));
      try {
        const response = await Requests.storeResetPasswordCall(id, token, payload);
        if (response.data) {
          dispatch(resetPasswordSuccess(true));
          return { status: true, message: response?.data?.message };
        }
      } catch (err) {
        dispatch(resetPasswordFailure(true))
        return { status: false, message: err?.response?.data?.error };
      }
    };
  };
  
